import * as userActions from '../user/actions';
import * as FOIVBigSubThemesActions from './actions';
import { CLEAN_PERSISTED_STORAGE } from '~redux_related/GENERAL/actions';

const initialState = {
    list: null,
    isFetching: false,
    isLoaded: false,
    error: '',
};

export const FOIVBigSubThemesReducer = (state = initialState, action) => {
    switch (action.type) {
        case FOIVBigSubThemesActions.SET_FOIV_BIG_SUB_THEMES_FETCHING:
            return {
                ...state,
                isFetching: action.isFetching,
            };

        case FOIVBigSubThemesActions.SET_FOIV_BIG_SUB_THEMES_ERROR:
            return {
                list: null,
                isFetching: false,
                isLoaded: true,
                error: action.error,
            };

        case FOIVBigSubThemesActions.SET_FOIV_BIG_SUB_THEMES:
            return {
                list: action.list,
                isFetching: false,
                isLoaded: true,
                error: '',
            };

        case FOIVBigSubThemesActions.ABORT_FOIV_BIG_SUB_THEMES_REQUEST:
            return initialState;

        case FOIVBigSubThemesActions.CLEAN_FOIV_BIG_SUB_THEMES:
            return initialState;

        case userActions.LOGOUT:
            return initialState;

        case userActions.LOGIN:
            // console.log('+++LOGIN USER 11+++');
            return initialState;

        case CLEAN_PERSISTED_STORAGE:
            console.log('+++CLEAN PERSISTED STORAGE 14+++');
            return initialState;

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/redux_related/FOIVBigSubThemes/reducer.js